import { useTranslation } from "react-i18next";
import { useSearchParams } from "react-router-dom";
import PageWrapper from "../../components/common/layout/PageWrapper";
import { baseEndpointPaths, getApplicationById } from "../../../services/serviceCalls";
import SeAdditionalDocView from "../../components/services/additionalDoc/SeAdditionalDocView";

const SeAdditionalDocViewPage = ({ titleCode }) => {
  const { t } = useTranslation();
  const [searchParams] = useSearchParams();
  const id = searchParams.get("id");

  return (
    <PageWrapper title={t(`${titleCode}.view`)}>
      <SeAdditionalDocView serviceFn={getApplicationById(baseEndpointPaths.seAdditionalDoc, id)} />
    </PageWrapper>
  );
};
export default SeAdditionalDocViewPage;
